import { ReactNode } from 'react'
import { Breadcrumb } from '@/ui'
import { useNavigate } from 'react-router-dom'

import { getUserNameById } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'

export const UserBreadcrumbs = ({
  userId,
  pageName,
  children,
}: {
  userId: number | string | undefined
  pageName?: string
  children?: ReactNode
}) => {
  const userName = useReselector(getUserNameById, userId)
  const navigate = useNavigate()
  if (!userName) {
    return null
  }

  return (
    <Breadcrumb>
      <Breadcrumb.List>
        <Breadcrumb.Item>
          {' '}
          <Breadcrumb.Link
            onClick={() => {
              navigate('/')
            }}
          >
            Dashboard
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        <Breadcrumb.Separator />
        <Breadcrumb.Item>
          <Breadcrumb.Link
            onClick={() => {
              navigate('/admin/finances/list-users')
            }}
          >
            Users
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        <Breadcrumb.Separator />
        {/*Display link only if there are other tabs*/}
        <Breadcrumb.Item>
          {pageName || children ? (
            <Breadcrumb.Link
              onClick={() => {
                navigate(`/admin/finances/records/${userId}`)
              }}
            >
              {userName}
            </Breadcrumb.Link>
          ) : (
            userName
          )}
        </Breadcrumb.Item>
        {pageName && (
          <>
            <Breadcrumb.Separator />
            <Breadcrumb.Page>{pageName}</Breadcrumb.Page>
          </>
        )}
        {children}
      </Breadcrumb.List>
    </Breadcrumb>
  )
}
